import { useUpgradeTracking } from '@/hooks/useUpgradeTracking';
import { accountSelector } from '@/redux/features/plan.slice';
import { LayoutTopHome as CrossSaleTopHome } from '@xipat/cross-sale/polaris';
import { useSelector } from 'react-redux';

function LayoutTopHome() {
  const { shopId } = useSelector(accountSelector);
  const { captureEvent } = useUpgradeTracking();

  if (!shopId) return null;

  return (
    <CrossSaleTopHome
      apiUrl="https://cross-sale.omegatheme.com"
      appHandle={process.env.REACT_APP_SHOPIFY_APP_HANDLE || 'ot'}
      shopId={String(shopId)}
      onTrack={(e) =>
        captureEvent(e.event, {
          placement_id: e.placementId,
          layout_id: e.layoutId,
          host_app: e.hostApp,
          shop_id: e.shopId,
        })
      }
    />
  );
}

export default LayoutTopHome;
